import React, { useMemo } from 'react';
import Title from '../Title';
import Card from '../../../../muiComponents/Card';
import {
    usePropertyFetching,
    usePropertyPresentation,
    usePropertySaving,
    useZitoneoHotelAttributes,
} from '../../../contextsProperty/ContextProperties';
import { sortAttributeDefinitions } from '../../../../utils/property/propertyZinantisUtils';
import HotelAttributesSection from './HotelAttributesSection';
import LoadingZitoneoHotelAttributes from './LoadingZitoneoHotelAttributes';
import Button from '../../../../muiComponents/Button';
import useTranslate from '../../../../customHooks/useTranslate';
import { useHistory } from 'react-router-dom';
import { URL_HOTEL_BASE } from '../../../../utils/property/propertyUtils';
import { PresentationTabNames } from '../../../../types/properties/propertyTypes';

const ZitoneoHotelAttributes = () => {
    const translate = useTranslate();
    const history = useHistory();
    const {
        attributeDefinitions,
        attributeValues,
        handlePropertyAttributeValueChange,
        handleDeleteHotelAttributeValue,
    } = useZitoneoHotelAttributes();

    const { isFetching } = usePropertyFetching();
    const { handleSave } = usePropertySaving();
    const { id, changePresentationTab } = usePropertyPresentation();

    const sortedAttributeDefinitions = useMemo(() => {
        return attributeDefinitions
            ? sortAttributeDefinitions(attributeDefinitions)
            : [];
    }, [attributeDefinitions]);

    const categories = useMemo(() => {
        return attributeDefinitions.reduce(
            (acc: Array<{ id: number; category: string }>, attribute) => {
                if (!attribute.idCategory) {
                    return acc;
                }

                if (!acc.find(item => item.id === attribute.idCategory)) {
                    acc.push({
                        id: attribute.idCategory,
                        category: attribute.category,
                    });
                }

                return acc;
            },
            [] as Array<{ id: number; category: string }>
        );
    }, [attributeDefinitions]);

    if (isFetching) {
        return <LoadingZitoneoHotelAttributes />;
    }

    const comeBackToPresentation = () => {
        history.push(URL_HOTEL_BASE(id));
    };

    const handleClickSave = async () => {
        await handleSave();
        comeBackToPresentation();
        changePresentationTab(PresentationTabNames.ZITONEO);
    };

    return (
        <div className='flex-grow flex-column flex-align-center width100perc'>
            <div className='zitoneo-services-page__content '>
                <header>
                    <Title text={'property_attributes'} />
                </header>
                <Card className='padding20 flex-column gap-40'>
                    {/* without category */}
                    <HotelAttributesSection
                        attributeDefinitions={sortedAttributeDefinitions.filter(
                            attributeDefinition =>
                                !attributeDefinition.idCategory
                        )}
                        attributeValues={attributeValues}
                        onChangeAttributeValue={
                            handlePropertyAttributeValueChange
                        }
                        onDeleteAttributeValue={handleDeleteHotelAttributeValue}
                    />
                    {categories.map(category => {
                        const categoryAttributeDefinitions =
                            sortedAttributeDefinitions.filter(
                                attributeDefinition =>
                                    attributeDefinition.idCategory ===
                                    category.id
                            );
                        if (categoryAttributeDefinitions.length) {
                            return (
                                <HotelAttributesSection
                                    key={category.id}
                                    title={category.category}
                                    attributeDefinitions={
                                        categoryAttributeDefinitions
                                    }
                                    attributeValues={attributeValues}
                                    onChangeAttributeValue={
                                        handlePropertyAttributeValueChange
                                    }
                                    onDeleteAttributeValue={
                                        handleDeleteHotelAttributeValue
                                    }
                                />
                            );
                        }
                        return null;
                    })}
                </Card>
            </div>
            <div className='your-properties__footer flex-end'>
                <Button variant='contained' onClick={handleClickSave}>
                    {translate('save')}
                </Button>
            </div>
        </div>
    );
};

export default ZitoneoHotelAttributes;
